import { type ContactAddress } from 'src/api/generated';
import Label from 'src/modules/shared/components/atoms/inputs/label';
import { EditableAddressField } from 'src/modules/communications/components/molecules/contacts/editable-address-field';

interface ContactAddressItemProps {
  address: ContactAddress;
  label: string;
  labelSize: 'xs' | 'sm';
  loading: boolean;
  onSave: (data: { address: string }) => Promise<void>;
  onDelete: () => Promise<void>;
  onAction?: (address: string) => void;
  actionDisabled: boolean;
  actionLoading: boolean;
  actionTooltip?: string;
  readOnlyTooltip?: string;
}

export const ContactAddressItem: React.FC<ContactAddressItemProps> = ({
  address,
  label,
  labelSize,
  loading,
  onSave,
  onDelete,
  onAction,
  actionDisabled,
  actionLoading,
  actionTooltip,
  readOnlyTooltip,
}) => (
  <div className="space-y-0.5">
    <Label
      size={labelSize}
      variant="secondary"
      layout="stacked"
      className="break-words"
    >
      {label}
    </Label>
    <EditableAddressField
      address={address.address}
      channelType={address.channelType}
      onSave={onSave}
      onDelete={onDelete}
      loading={loading}
      onAction={onAction}
      actionDisabled={actionDisabled}
      actionLoading={actionLoading}
      actionTooltip={actionTooltip}
      size="md"
      readOnlyTooltip={readOnlyTooltip}
    />
  </div>
);
